import axios from "axios";
import authHeader from "./auth-header";
import ISale from "../types/sale.type";
import {toFormData} from "./utils.axios";


const API_URL = `${process.env.REACT_APP_SERVER_URL}/sale`;

export const getById = (id: any) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (sale: ISale) => {
  const headers = authHeader();
  headers['Content-Type'] = 'multipart/form-data';
  const formData = toFormData(sale);
  return axios.post(API_URL, formData, { headers: headers });
};

export const update = (id: number, sale: ISale) => {
  const headers = authHeader();
  headers['Content-Type'] = 'multipart/form-data';
  const formData = toFormData(sale);
  // Realizar la petición PUT utilizando Axios y el FormData construido
  return axios.put(`${API_URL}/${id}`, formData, { headers });
};


export const deleteById = (id: any) => {
  return axios.delete(API_URL + "/" + id, { headers: authHeader() });
};

export const getSales = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const exportSales = async (params: {}) => {
  const response = await axios.get(`${API_URL}/export`, {
    params: params,
    headers: authHeader(),
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"];
  const fileNameMatch = contentDisposition?.match(/filename="?([^"]+)"?/);
  const fileName = fileNameMatch?.[1] ?? "compras.xlsx";

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(url);
};
